import React from "react";
import * as Icons from "lucide-react";
import { PROCESS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Process = () => (
  <section id="process" className="relative py-24 md:py-32 bg-[#0d0d0d] overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="text-center mb-16">
        <Reveal><Eyebrow color="#F56FB4">How It Works</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-heading font-extrabold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight mt-3">
            From Clutter to <span className="text-[#53C653]">Clarity</span>
          </h2>
        </Reveal>
      </div>

      <div className="relative grid md:grid-cols-4 gap-8 md:gap-6">
        {/* connecting line */}
        <div className="hidden md:block absolute top-9 left-[12%] right-[12%] h-px bg-gradient-to-r from-[#F56FB4]/40 via-white/15 to-[#53C653]/40" />
        {PROCESS.map((p, i) => {
          const Icon = Icons[p.icon] || Icons.Circle;
          const accent = i === 3 ? "#53C653" : "#F56FB4";
          return (
            <Reveal key={p.step} delay={i * 0.12} className="relative">
              <div className="flex flex-col items-center text-center md:items-start md:text-left">
                <div className="relative z-10 mb-6">
                  <div
                    className="h-[72px] w-[72px] rounded-full flex items-center justify-center bg-[#111111]"
                    style={{ border: `2px solid ${accent}`, boxShadow: `0 0 25px ${accent}40` }}
                  >
                    <Icon size={30} style={{ color: accent }} />
                  </div>
                  <span className="absolute -top-2 -right-2 h-7 w-7 rounded-full bg-white text-[#111111] text-xs font-heading font-extrabold flex items-center justify-center">
                    {p.step}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-xl text-white uppercase tracking-tight">{p.title}</h3>
                <p className="text-sm text-white/55 mt-2 leading-relaxed max-w-[15rem]">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Process;
